import TinyColor from "@ctrl/tinycolor";
import { InputElement } from "@redotech/redo-model/forge/marketing-signup-forge-types";
import * as classNames from "classnames";
import { memo, useState } from "react";
import { BrandKitTextInput } from "../../brand-kit-text-input";
import { ExternalLink } from "../../link";
import { Text } from "../../text";
import * as signupFormCss from "../signup-form.module.css";
import { FormElementProps } from "./index";

export const Input = memo(function Input({
  form,
  brandKit,
  element,
}: FormElementProps<InputElement>) {
  const [value, setValue] = useState("");
  return (
    <>
      <BrandKitTextInput
        brandKit={brandKit}
        inputTypeHint={element.inputType === "email" ? "email" : "tel"}
        name={element.inputType}
        override={
          form.theme.overrides.inputs.enabled
            ? form.theme.overrides.inputs
            : undefined
        }
        placeholder={element.placeholderText}
        required
        setValue={setValue}
        value={value}
      />
      {element.inputType === "phone" && (
        <Text
          className={classNames(
            signupFormCss.legalDisclaimer,
            TinyColor(form.layout.backgroundColor).isDark()
              ? signupFormCss.invertedTextColor
              : undefined,
          )}
          dir="column"
          mt="lg"
        >
          By providing your phone number, you agree to receive recurring
          automated marketing text messages (e.g. cart reminders) from this shop
          and third parties acting on its behalf. Consent is not a condition to
          obtain goods or services. Msg & data rates may apply. Msg frequency
          varies. Reply HELP for help and STOP to cancel. You also agree to the{" "}
          <ExternalLink
            showIcon={false}
            url="https://www.getredo.com/terms-conditions"
          >
            Terms of Service
          </ExternalLink>{" "}
          and{" "}
          <ExternalLink
            showIcon={false}
            url="https://www.getredo.com/privacy-policy"
          >
            Privacy Policy.
          </ExternalLink>
        </Text>
      )}
    </>
  );
});
